import { useEffect, useMemo } from 'react'
import { createPortal } from 'react-dom'

import style from './BlurApp.module.scss'

const modalRootElement = document.querySelector('#blur_app')

export const BlurApp: React.FC<{
    show: boolean
    withScroll?: boolean
}> = (props) => {
    const { show, withScroll = false } = props

    const element = useMemo(() => document.createElement('div'), [])

    useEffect(() => {
        if (show) {
            modalRootElement?.appendChild(element)
            return () => {
                modalRootElement?.removeChild(element)
            }
        }
    }, [show, element])

    useEffect(() => {
        if (show && !withScroll) {
            document.body.style.overflow = 'hidden'
        }
        return () => {
            document.body.style.overflow = 'unset'
        }
    }, [show, withScroll])

    return createPortal(<div className={style.container}></div>, element)
}
